import React, { useState, useEffect } from "react";
import { ZebpayWalletdata } from "../../../Service/Broker.service.jsx";
function Zebpay() {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );
  const [walletdata, setWalletdata] = useState([]);

  useEffect(() => {
    getZebpayWallet();
  }, []);

  const getZebpayWallet = async () => {
    const data = {
      user_id: user_details?.user_id,
      token: user_details?.token,
    };
    const response = await ZebpayWalletdata(data);
    if (response.status) {

      setWalletdata(response.data.data);
    } else {
      console.error("Error fetching Zebpay wallet data:", response.error);
    }
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-centered table-nowrap mb-0 rounded">
          <thead className="thead-light">
            <tr>
              <th>Currency</th>
              <th>Balance</th>
              <th>Available</th>
              <th>Locked</th>
            </tr>
          </thead>
          <tbody>
            {walletdata &&
              walletdata?.map((item, index) => (
                <tr key={index}>
                  <td>{item.currency}</td>
                  <td>{item.balance}</td>
                  <td>{item.available}</td>
                  <td>{item.locked}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Zebpay;
